import { render } from "./ComList.vue?vue&type=template&id=07ff5a8c&scoped=true"
import script from "./ComList.vue?vue&type=script&lang=js"
export * from "./ComList.vue?vue&type=script&lang=js"

import "./ComList.vue?vue&type=style&index=0&id=07ff5a8c&lang=less&scoped=true"

import exportComponent from "E:\\wwwroot\\abz-shuzi\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07ff5a8c"]])

export default __exports__